import React, { useEffect, useState } from 'react';
import { useParams, Link, useOutletContext, useSearchParams } from 'react-router-dom';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import styles from './PuppyListings.module.scss';
import PublicTable from '../../Shared/PublicTable/PublicTable';
import { Form, Modal, Button } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import backgroundImage from '../../../Assets/Images/background.svg';
import BreedDropdown from '../../Shared/BreedDropdown/BreedDropdown';
import { ExternalLayoutContext } from '../ExternalLayout';

function PuppyListings() {
    const t = useTranslate();
    const params = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [loading, setLoading] = useState(true);
    const [puppies, setPuppies] = useState<any[]>([]);
    const [filteredPuppies, setFilteredPuppies] = useState<any[]>([]);
    const { breeds, selectedBreed, handleBreedChange, setBackLink } = useOutletContext<ExternalLayoutContext>();
    
    // Modal states
    const [showColumnModal, setShowColumnModal] = useState(false);
    
    // Schema for malepartnerreq
    const [malepartnerreqSchema, setMalepartnerreqSchema] = useState<any | undefined>();
    
    // Sorting state (mirrors PublicTable's internal sorting)
    const [sortField, setSortField] = useState<string>('');
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
    const [collapsedGroups, setCollapsedGroups] = useState<Set<string>>(new Set(['Kontaktinfo']));


    const availableColumnsDefault = [
        { column_group: 'Mor', collapsed_icon: '♀️', id: 'DAM_NAME', label: 'Mor Navn', visible: true, order: 0 },
        { column_group: 'Mor', collapsed_icon: '♀️', id: 'DAM_REGNO', label: 'Mor Reg.Nr', visible: true, order: 1 },
        { column_group: 'Mor', collapsed_icon: '♀️', id: 'DAM_TITLE_CLASS', label: 'Mor Utst', visible: true, order: 2 },
        { column_group: 'Mor', collapsed_icon: '♀️', id: 'DAM_TITLE_PRIZE', label: 'Mor Titler', visible: true, order: 3 },

        { column_group: 'Far', collapsed_icon: '♂️', id: 'SIRE_NAME', label: 'Far Navn', visible: true, order: 4 },
        { column_group: 'Far', collapsed_icon: '♂️', id: 'SIRE_REGNO', label: 'Far Reg.Nr', visible: true, order: 5 },
        { column_group: 'Far', collapsed_icon: '♂️', id: 'SIRE_TITLE_CLASS', label: 'Far Utst', visible: true, order: 6 },
        { column_group: 'Far', collapsed_icon: '♂️', id: 'SIRE_TITLE_PRIZE', label: 'Far Titler', visible: true, order: 7 },

        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'OWNER_NAME', label: 'Navn Oppdretter', visible: true, order: 8 },
        //{ column_group: '', id: 'BREEDER_NAME', label: 'Navn Oppdretter', visible: true, order: 8 },
        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'KENNEL_NAME', label: 'Navn Kennel', visible: true, order: 9 },
        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'PHONE', label: 'Telefon', visible: true, order: 10 },
        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'EMAIL', label: 'Epost', visible: true, order: 11 },
        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'POSTAL_CODE', label: 'Postnummer', visible: true, order: 12 },
        { column_group: 'Kontaktinfo', collapsed_icon: '📞', id: 'POSTAL_AREA', label: 'Sted', visible: true, order: 13 },

        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'INNAVL_AVKOM', label: 'Innavls (5g)', visible: true, order: 14 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'INNAVL_AVKOM_8_GEN', label: 'Innavls (8g)', visible: true, order: 15 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'RELATIONSHIP_INDEX', label: 'Slektskapsverdi', visible: true, order: 16 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'HD_INDEX', label: 'HD-index samlet', visible: true, order: 17 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'DWARF', label: 'Dvergvekst', visible: true, order: 18 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'ATAKSI', label: 'Ataksi', visible: true, order: 19 },
        { column_group: 'Fiktive Helseverdier', collapsed_icon: '🏥', id: 'GLAUKOM', label: 'Glaukom', visible: true, order: 20 },
        
        { column_group: 'Bruksindekser Bandhund', collapsed_icon: '🎯', id: 'M1_EBV_BAND', label: 'M1 - Søk', visible: true, order: 21 },
        { column_group: 'Bruksindekser Bandhund', collapsed_icon: '🎯', id: 'M2_EBV_BAND', label: 'M2 - Evnen til å finne', visible: true, order: 22 },

        { column_group: 'Bruksindekser Løshund', collapsed_icon: '🌲', id: 'M1_EBV_LOS', label: 'M1 - Søk', visible: true, order: 23 },
        { column_group: 'Bruksindekser Løshund', collapsed_icon: '🌲', id: 'M3_EBV_LOS', label: 'M3 - Evne til å stille elg i uttaket', visible: true, order: 24 },
        { column_group: 'Bruksindekser Løshund', collapsed_icon: '🌲', id: 'M5_EBV_LOS', label: 'M5 - Påhengelighet', visible: true, order: 25 },
        { column_group: 'Bruksindekser Løshund', collapsed_icon: '🌲', id: 'M9_EBV_LOS', label: 'M9 - Bruken av målet', visible: true, order: 26 },

        { column_group: 'Status', collapsed_icon: '📋', id: 'EXPECTING_DATE', label: 'Forventet Parring', visible: true, order: 27 },
        { column_group: 'Status', collapsed_icon: '📋', id: 'STATUS', label: 'Status Parring', visible: true, order: 28 },
        { column_group: 'Status', collapsed_icon: '📋', id: 'BIRTHDATE', label: 'Født Dato', visible: true, order: 29 },
        { column_group: 'Status', collapsed_icon: '📋', id: 'PUPSBORN', label: 'Født Valper', visible: true, order: 30 },
        { column_group: 'Status', collapsed_icon: '📋', id: 'FREETEXT', label: 'Fritekst', visible: true, order: 31 },
    ];
    
    // Column configuration for puppies
    const [availableColumns, setAvailableColumns] = useState(availableColumnsDefault);
    
    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPuppies, setTotalPuppies] = useState(0);

    // Cache keys
    const COLUMN_CACHE_KEY = 'puppyListings_columnConfig_v3'; // Updated for new column structure

    // Cache functions
    const saveColumnConfigToCache = (config: any[]) => {
        try {
            localStorage.setItem(COLUMN_CACHE_KEY, JSON.stringify(config));
        } catch (error) {
            console.log('Could not save column config to cache:', error);
        }
    };

    const loadColumnConfigFromCache = (): any[] | null => {
        try {
            const cached = localStorage.getItem(COLUMN_CACHE_KEY);
            return cached ? JSON.parse(cached) : null;
        } catch (error) {
            console.log('Could not load column config from cache:', error);
            return null;
        }
    };

    const clearCache = () => {
        try {
            localStorage.removeItem(COLUMN_CACHE_KEY);
            console.log('Cache cleared successfully');
        } catch (error) {
            console.log('Could not clear cache:', error);
        }
    };

    function formatExpectingDate(date: string): string {
        if (!date) return '';
        const parts = date.split('.');
        if (parts.length === 2) {
            const monthNumber = parts[0];
            const year = parts[1];
            const months: { [key: string]: string } = {
                '01': t('editpuppylisting.form.months.january'),
                '02': t('editpuppylisting.form.months.february'),
                '03': t('editpuppylisting.form.months.march'),
                '04': t('editpuppylisting.form.months.april'),
                '05': t('editpuppylisting.form.months.may'),
                '06': t('editpuppylisting.form.months.june'),
                '07': t('editpuppylisting.form.months.july'),
                '08': t('editpuppylisting.form.months.august'),
                '09': t('editpuppylisting.form.months.september'),
                '10': t('editpuppylisting.form.months.october'),
                '11': t('editpuppylisting.form.months.november'),
                '12': t('editpuppylisting.form.months.december')
            };
            const monthName = months[monthNumber] || monthNumber;
            return `${monthName} ${year}`;
        }
        return date;
    }

    useEffect(() => {
        // Load cached column configuration
        const cachedColumns = loadColumnConfigFromCache();
        if (cachedColumns) {
            setAvailableColumns(cachedColumns);
        }
    }, []);

    useEffect(() => {
        if (params.breedid) {
            handleBreedChange(params.breedid);
        }
    }, [params.breedid]);

    useEffect(() => {
        setBackLink({
            to: selectedBreed && malepartnerreqSchema ? `/skjema/dyn/${selectedBreed}/${malepartnerreqSchema.ID}` : '/external',
            text: selectedBreed && malepartnerreqSchema ? 'Forespør anbefaling av hannhund' : '← Tilbake til hovedsiden',
            openInNewTab: !!(selectedBreed && malepartnerreqSchema)
        });
    }, [selectedBreed, malepartnerreqSchema]);

    useEffect(() => {
        return () => setBackLink(undefined);
    }, []);

    useEffect(() => {
        if (selectedBreed && selectedBreed !== '') {
            getPuppyListings();
            getMalepartnerreqSchema();
        }
    }, [selectedBreed]);

    useEffect(() => {
        // Apply sorting to match PublicTable's internal sorting
        let sorted = [...puppies];
        
        if (sortField) {
            sorted.sort((a, b) => {
                let aValue = a[sortField];
                let bValue = b[sortField];

                // Convert to lowercase for case-insensitive text sorting
                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue === bValue) return 0;
                if (sortDirection === 'asc') {
                    return aValue < bValue ? -1 : 1;
                } else {
                    return bValue < aValue ? -1 : 1;
                }
            });
        }
        
        setFilteredPuppies(sorted);
        setCurrentPage(1); // Reset to first page when data or sorting changes
    }, [puppies, sortField, sortDirection]);

    function getBreeds() {return;}

    function getPuppyListings() {
        setLoading(true);
        
        // Set Available Columns to default before fetching data
        setAvailableColumns(availableColumnsDefault);

        axios.single({
            method: 'get',
            url: `/api/dogs/puppylistings/${selectedBreed}`,
            responseType: 'json',
        }).then((res: any) => {
            const allPuppies = res.data || [];
            console.log(`API returned ${allPuppies.length} puppies`);
            
            // Check which columns are missing from API data
            if (allPuppies.length > 0) {
                const apiFields = new Set(allPuppies.flatMap((row: any) => Object.keys(row)));
                const configuredColumns = availableColumns.map(col => col.id);
                const missingColumns = configuredColumns.filter(col => !apiFields.has(col));
                
                if (missingColumns.length > 0) {
                    console.log('Columns configured but missing from API data:', missingColumns);
                }
            
                // Remove the missing columns from availableColumns state
                if (missingColumns.length > 0) {
                    setAvailableColumns(prevColumns => 
                        prevColumns.filter(col => !missingColumns.includes(col.id))
                    );
                }
            }
            
            setPuppies(allPuppies);
            setTotalPuppies(allPuppies.length);
        }).catch((err: any) => {
            console.log(err);
            setPuppies([]);
            setTotalPuppies(0);
        }).finally(() => {
            setLoading(false);
        });
    }

    function getMalepartnerreqSchema() {
        if (!selectedBreed) return;
        
        console.log('Fetching malepartnerreq schema for breed:', selectedBreed);
        axios.single({
            method: 'get',
            url: `/api/dynschema/special/${selectedBreed}/malepartnerreq`,
            responseType: 'json',
        }).then((res: any) => {
            console.log('Malepartnerreq schema response:', res.data);
            setMalepartnerreqSchema(res.data);
        }).catch((err: any) => {
            console.log('Error fetching malepartnerreq schema:', err);
        });
    }

    function getTableHeaders() {
        const visibleColumns = availableColumns
            .filter(col => col.visible)
            .sort((a, b) => a.order - b.order);
        
        const overrides: Record<string, (data: any) => string> = {
            'STATUS': (data: any) => {
                switch (data.STATUS) {
                    case 'awaiting': return 'Ikke gjennomført';
                    case 'mated': return 'Parring gjennomført';
                    case 'attempted': return 'Parring uten resultat';
                    case 'failed': return 'Parring mislykket';
                    case 'successful': return 'Valper født';
                    default: return data.STATUS || 'Ukjent';
                }
            },
            'EXPECTING_DATE': (data: any) => formatExpectingDate(data.EXPECTING_DATE),
            'BIRTHDATE': (data: any) => data.BIRTHDATE || '',
            'PUPSBORN': (data: any) => {
                if (!data.PUPSBORN) return '';
                const parts = data.PUPSBORN.split('|');
                if (parts.length === 2) {
                    return `Hanner: ${parts[0]} | Tisper: ${parts[1]}`;
                }
                return data.PUPSBORN;
            },
            'FREETEXT': (data: any) => data.FREETEXT || '',
            'DAM_NAME': (data: any) => data.DAM_NAME || '',
            'DAM_REGNO': (data: any) => data.DAM_REGNO || '',
            'DAM_TITLE_CLASS': (data: any) => data.DAM_TITLE_CLASS || '',
            'SIRE_NAME': (data: any) => data.SIRE_NAME || '',
            'SIRE_REGNO': (data: any) => data.SIRE_REGNO || '',
            'SIRE_TITLE_CLASS': (data: any) => data.SIRE_TITLE_CLASS || '',
            'OWNER_NAME': (data: any) => data.OWNER_NAME || '',
            'POSTAL_CODE': (data: any) => data.POSTAL_CODE || '',
            'POSTAL_AREA': (data: any) => data.POSTAL_AREA || '',
            'PHONE': (data: any) => data.PHONE || '',
            'EMAIL': (data: any) => data.EMAIL || ''
        };
        
        return visibleColumns.map(col => {
            const baseColumn: any = {
                column_group: col.column_group,
                collapsed_icon: col.collapsed_icon,
                label: col.label,
                field: col.id
            };

            // Setting maxWidth for specific columns to prevent layout issues
            switch (col.id) {
                case 'FREETEXT':
                    baseColumn.maxWidth = '500px';
                    break;
                case 'DAM_TITLE_CLASS':
                case 'SIRE_TITLE_CLASS':
                case 'DAM_TITLE_PRIZE':
                case 'SIRE_TITLE_PRIZE':
                    baseColumn.maxWidth = '180px';
                    break;
            }

            return overrides[col.id] 
                ? { ...baseColumn, override: overrides[col.id] }
                : baseColumn;
        });
    }

    function getPaginatedData() {
        const startIndex = (currentPage - 1) * rowsPerPage;
        const endIndex = startIndex + rowsPerPage;
        return filteredPuppies.slice(startIndex, endIndex);
    }

    function handleColumnToggle(columnId: string) {
        setAvailableColumns(prev => {
            const newColumns = prev.map(col => 
                col.id === columnId ? { ...col, visible: !col.visible } : col
            );
            saveColumnConfigToCache(newColumns);
            return newColumns;
        });
    }

    function handleColumnOrderChange(columnId: string, direction: 'up' | 'down') {
        setAvailableColumns(prev => {
            const newColumns = [...prev];
            const currentIndex = newColumns.findIndex(col => col.id === columnId);
            
            if (direction === 'up' && currentIndex > 0) {
                [newColumns[currentIndex], newColumns[currentIndex - 1]] = [newColumns[currentIndex - 1], newColumns[currentIndex]];
                newColumns[currentIndex].order = currentIndex;
                newColumns[currentIndex - 1].order = currentIndex - 1;
            } else if (direction === 'down' && currentIndex < newColumns.length - 1) {
                [newColumns[currentIndex], newColumns[currentIndex + 1]] = [newColumns[currentIndex + 1], newColumns[currentIndex]];
                newColumns[currentIndex].order = currentIndex;
                newColumns[currentIndex + 1].order = currentIndex + 1;
            }
            
            saveColumnConfigToCache(newColumns);
            return newColumns;
        });
    }

    return (
        <div 
            className={styles.puppyListings}
            style={{ '--background-image': `url(${backgroundImage})` } as React.CSSProperties}
        >
            <div className={styles.backgroundTail}></div>

            {selectedBreed && <><div className={styles.mainContent}>
                <div className={styles.pageHeader}>
                    <div className={styles.headerRow}>
                        <h1>Valpeliste</h1>
                        <button 
                            className={styles.configureColumns}
                            onClick={() => setShowColumnModal(true)}
                        >
                            <span className={styles.gearIcon}>⚙️</span>
                            Konfigurer kolonner
                        </button>
                    </div>
                </div>

                {loading ? (
                    <div className={styles.loading}>
                        <p>Henter valpeliste...</p>
                    </div>
                ) : filteredPuppies.length > 0 ? (
                    <div className={styles.tableContainer}>
                        <PublicTable
                            headers={getTableHeaders().map(header => ({
                                ...header,
                                sortActive: sortField === header.field,
                                sortDirection: sortField === header.field ? sortDirection : 'asc',
                                // Intercept sort to update parent state
                                onSort: () => {
                                    if (sortField === header.field) {
                                        setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
                                    } else {
                                        setSortField(header.field);
                                        setSortDirection('asc');
                                    }
                                }
                            }))}
                            data={getPaginatedData()}
                            collapsedGroups={collapsedGroups}
                            onGroupToggle={(group) => setCollapsedGroups(prev => {
                                const next = new Set(prev);
                                if (next.has(group)) next.delete(group); else next.add(group);
                                return next;
                            })}
                        />
                    </div>
                ) : (
                    <div className={styles.noResults}>
                        <p>Ingen valper funnet</p>
                    </div>
                )}

                {filteredPuppies.length > 0 && (
                    <div>
                        <div className={styles.pagination}>
                            <button
                                onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                disabled={currentPage === 1}
                                className={styles.paginationButton}
                            >
                                Forrige
                            </button>
                            
                            <div className={styles.pageNumbers}>
                                {Array.from({ length: Math.ceil(filteredPuppies.length / rowsPerPage) }, (_, i) => i + 1)
                                    .slice(Math.max(0, currentPage - 3), Math.min(Math.ceil(filteredPuppies.length / rowsPerPage), currentPage + 2))
                                    .map(page => (
                                        <button
                                            key={page}
                                            onClick={() => setCurrentPage(page)}
                                            className={`${styles.pageNumber} ${page === currentPage ? styles.active : ''}`}
                                        >
                                            {page}
                                        </button>
                                    ))}
                            </div>
                            
                            <button
                                onClick={() => setCurrentPage(Math.min(Math.ceil(filteredPuppies.length / rowsPerPage), currentPage + 1))}
                                disabled={currentPage === Math.ceil(filteredPuppies.length / rowsPerPage)}
                                className={styles.paginationButton}
                            >
                                Neste
                            </button>
                        </div>
                        <div className={styles.rowsPerPageSelector}>
                            <label htmlFor="rowsPerPage">Rader per side:</label>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                                className={styles.rowsPerPageSelect}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={15}>15</option>
                                <option value={30}>30</option>
                                <option value={50}>50</option>
                            </select>
                        </div>
                    </div>
                )}
            </div>

            {/* Column Configuration Modal */}
            <Modal show={showColumnModal} onHide={() => setShowColumnModal(false)} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Konfigurer kolonner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.columnConfig}>
                        {availableColumns
                            .sort((a, b) => {
                                // Show visible columns first, then by order
                                if (a.visible !== b.visible) return b.visible ? 1 : -1;
                                return a.order - b.order;
                            })
                            .map((column, index) => (
                                <div key={column.id} className={styles.columnRow}>
                                    <div className={styles.columnCheckWrapper}>
                                        <Form.Check
                                            type="checkbox"
                                            id={`col-${column.id}`}
                                            label={column.label}
                                            checked={column.visible}
                                            onChange={() => handleColumnToggle(column.id)}
                                        />
                                        {column.column_group && collapsedGroups.has(column.column_group) && (
                                            <span className={styles.collapsedBadge} title={`Gruppen "${column.column_group}" er skjult i tabellen`}>
                                                ▶ Skjult
                                            </span>
                                        )}
                                    </div>
                                    <div className={styles.columnControls}>
                                        <button
                                            className={styles.orderButton}
                                            onClick={() => handleColumnOrderChange(column.id, 'up')}
                                            disabled={index === 0}
                                        >
                                            ↑
                                        </button>
                                        <button
                                            className={styles.orderButton}
                                            onClick={() => handleColumnOrderChange(column.id, 'down')}
                                            disabled={index === availableColumns.length - 1}
                                        >
                                            ↓
                                        </button>
                                    </div>
                                </div>
                            ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowColumnModal(false)}>
                        Lukk
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
            }
        </div>
    );
}

export default PuppyListings;
